import React, { FC, useState, useEffect } from "react";

import { TSuggestionsProps } from "../../types/Suggestions.type";
import "./styles.scss";

const Suggestions: FC<TSuggestionsProps> = ({
  suggestionQuery,
  contextId,
  language,
  minimalLength,
  onUpdateQuery,
  className,
}) => {
  const [suggestions, setSuggestions] = useState([]);

  const updateSuggestions = () => {
    if (!suggestionQuery || suggestionQuery.length < minimalLength) {
      setSuggestions([]);
      return;
    }

    const suggestionApiUrl = `/search-suggestions/${suggestionQuery}?contextId=${contextId}&language=${language}`;
    fetch(suggestionApiUrl)
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error(`${res.status} : Failed to fetch search suggestions.`);
        }
      })
      .then((result) => {
        if (result?.length) {
          setSuggestions(result);
        } else {
          setSuggestions([]);
        }
      })
      .catch(() => {
        setSuggestions([]);
      });
  };

  useEffect(() => updateSuggestions(), [suggestionQuery]);

  if (!suggestions) {
    return null;
  }

  return (
    suggestions && (
      <ul className={`search-suggestions ${className || ""}`}>
        {suggestions.map((suggestion, i) => (
          <li className="search-suggestions__item" key={i}>
            <a
              className="search-suggestions__item__link"
              onClick={() => onUpdateQuery(suggestion)}
            >
              {suggestion}
            </a>
          </li>
        ))}
      </ul>
    )
  );
};

export default Suggestions;
